export const isDevelopment = () => process.env.NODE_ENV === 'development';
// export const isProduction = (): boolean => process.env.NODE_ENV === 'production';
export const isProduction = ['hr.baicizhan-people.com', 'cyamis.baicizhan.com', 'hr.cya-tech.cn'].includes(window.location.host);
